export function validateSpanishID(value) {
    if (!value) return false;

    const str = value.toString().toUpperCase().trim();

    // DNI / NIE / NIF valid characters
    const validChars = 'TRWAGMYFPDXBNJZSQVHLCKET';

    // NIEs starting with X, Y, Z
    const nieRexp = /^[XYZ][0-9]{7}[A-Z]$/;
    // Standard DNI
    const nifRexp = /^[0-9]{8}[A-Z]$/;
    // CIF (Legal entities)
    const cifRexp = /^[ABCDEFGHJKLMNPQRSUVW][0-9]{7}[0-9A-J]$/;

    // Check DNI
    if (nifRexp.test(str)) {
        const number = parseInt(str.substr(0, 8), 10);
        const letter = str.substr(8, 1);
        const charIndex = number % 23;
        return validChars.charAt(charIndex) === letter;
    }

    // Check NIE
    if (nieRexp.test(str)) {
        let niePrefix = str.charAt(0);
        let nieNumber = str.substr(1, 7);
        let nieLetter = str.substr(8, 1);

        if (niePrefix === 'X') niePrefix = '0';
        if (niePrefix === 'Y') niePrefix = '1';
        if (niePrefix === 'Z') niePrefix = '2';

        const number = parseInt(niePrefix + nieNumber, 10);
        const charIndex = number % 23;
        return validChars.charAt(charIndex) === nieLetter;
    }

    // Check CIF (simplified validation)
    if (cifRexp.test(str)) {
        const cifLetter = str.charAt(0);
        // Basic format check passed. 
        // Full algorithm is complex, often basic format check + checksum is enough for frontend.
        // Let's implement a basic checksum if needed, but for now strict format is a good start.
        // Actually, let's try to be a bit more robust if possible without overcomplicating.

        let sum = 0;
        let num = str.substr(1, 7);

        for (let i = 0; i < 7; i++) {
            let n = parseInt(num[i], 10);
            // Odd positions (1st, 3rd, 5th...) -> *2
            if (i % 2 === 0) {
                n *= 2;
                if (n > 9) n = parseInt(n / 10) + (n % 10);
                sum += n;
            } else {
                sum += n;
            }
        }

        const sumLastDigit = sum % 10;
        const controlDigit = sumLastDigit === 0 ? 0 : 10 - sumLastDigit;

        const controlChar = str.substr(8, 1);
        const controlCharIsNumber = !isNaN(parseInt(controlChar, 10));

        const controlLetters = 'JABCDEFGHI';

        // Some CIF types use number, some letter, some both
        // Just checking if calculated control matches either number or letter
        if (controlCharIsNumber) {
            return parseInt(controlChar, 10) === controlDigit;
        } else {
            return controlLetters[controlDigit] === controlChar;
        }
    }

    return false;
}
